import { Roles } from "../../Orders/enums";

const ORDER_LIFECYCLE_ALLOWED_ROLES: Roles[] = [
  Roles.EXECUTIVE,
  Roles.CODE_ALCHEMISTS,
  Roles.HEAD_OF_OPERATIONS,
];

export function canAccessOrderLifecycle(
  userSubType: string | undefined,
): boolean {
  if (!userSubType) return false;
  return ORDER_LIFECYCLE_ALLOWED_ROLES.includes(userSubType as Roles);
}
